
<template>
  <div class="privacy">
    <div class="container">
      <h1>privacy policy</h1>
      <p>
        This privacy policy describes how Lexi's Kitchen (“Lexi's Kitchen”, “us” or “we”) protects your (“you”, “the user”) privacy and your data.
      </p>
      <p>
        Regarding Amazon, “Alexa” means their Alexa Voice Service which includes third party services (like our skills) and other related Software.
      </p>
      <p>
        If you use one of our skills you fully agree to this privacy policy.
      </p>
      <h2>general</h2>
      <p>
        When you use our skills you have to talk to Alexa. This voice input is sent to Amazon and us where we use it to understand what our skill should do for you. This is absolutely necessary for our service to give you an appropriate answer.
      </p>
      <h2>data</h2>
      <p>
        We never share your personal data with third parties.
      </p>
      <p>
        To improve our services we analyze automatically how often utterances are spoken and other analytics. This is done automatically by Amazon in the Amazon Developer Portal.
      </p>
      <p>
        We store the kitchen inventory data that you provide to us through the alexa skill and/or web app in a database. This data is linked to your account by your username that you create before linking your account.
      </p>
      <p>
        If you would like to remove all of your data (account info, inventory entries, etc.) email mail@dylanallen.net from the email address associated with your account. Include your username and in the body of the email, and use the subject line "ERASE MY ACCOUNT".
      <h2>changes</h2>
      <p>
        Our skill and web app or parts of either may change or be updated at any time. Further, this Privacy Policy might change. You can find a link to this policy on the description page of the skill in the Alexa App or in the Alexa Store. Your continued use of our skill after changes of the Privacy Policy or the skill itself will be seen as your acceptance of both.
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'privacypolicy',
  beforeMount() {
    this.$store.commit('setHeaderClass', '');
  }
}
</script>

<style lang="scss" scoped>
  p {
    text-align: left;
    line-height: 1.5;
    margin-top: 20px;
  }
  h1, h2, h3 {
    text-align: left;
  }
  .container {
    max-width: 760px;
    margin: auto;
  }
</style>
